import { ENTITY_TYPE, IdentityType } from '../../models/entity.model';

export type OrgUsersIdentityFilterValue =
  (typeof ORG_USERS_IDENTITY_FILTER)[keyof typeof ORG_USERS_IDENTITY_FILTER];

export interface OrgUsersIdentityFilterOption {
  label: string;
  value: OrgUsersIdentityFilterValue;
}

export interface OrgUsersIdentityView {
  allowedTypes: ReadonlySet<IdentityType>;
  key: OrgUsersIdentityFilterValue;
}

export const ORG_USERS_IDENTITY_FILTER = {
  ALL: 'all',
  SERVICES: ENTITY_TYPE.M2M,
  USERS: ENTITY_TYPE.USER,
} as const;

export const ORG_USERS_IDENTITY_FILTER_OPTIONS: OrgUsersIdentityFilterOption[] = [
  { label: 'All identities', value: ORG_USERS_IDENTITY_FILTER.ALL },
  { label: 'Users', value: ORG_USERS_IDENTITY_FILTER.USERS },
  { label: 'Services', value: ORG_USERS_IDENTITY_FILTER.SERVICES },
];

export const ORG_USERS_IDENTITY_VIEWS: Record<
  OrgUsersIdentityFilterValue,
  OrgUsersIdentityView
> = {
  [ORG_USERS_IDENTITY_FILTER.ALL]: {
    allowedTypes: new Set<IdentityType>([ENTITY_TYPE.M2M, ENTITY_TYPE.USER]),
    key: ORG_USERS_IDENTITY_FILTER.ALL,
  },
  [ORG_USERS_IDENTITY_FILTER.SERVICES]: {
    allowedTypes: new Set<IdentityType>([ENTITY_TYPE.M2M]),
    key: ORG_USERS_IDENTITY_FILTER.SERVICES,
  },
  [ORG_USERS_IDENTITY_FILTER.USERS]: {
    allowedTypes: new Set<IdentityType>([ENTITY_TYPE.USER]),
    key: ORG_USERS_IDENTITY_FILTER.USERS,
  },
};
